import { BaseTableV2 } from "types/api/deal/schemaAddOns";
import { TableStats } from "types/api/deal/table";

export enum AccountNormalSide {
  DEBIT = "debit",
  CREDIT = "credit",
}

export enum AccountType {
  ASSET = "asset",
  LIABILITY = "liability",
  EQUITY = "equity",
  REVENUE = "revenue",
  EXPENSE = "expense",
}

// Interfaces
export interface LedgerAccountCreate {
  name: string;
  account_type: AccountType;
  normal_side: AccountNormalSide;
}

export interface LedgerAccountBase extends BaseTableV2, LedgerAccountCreate {
  organization_id: number;
}

export interface LedgerAccount extends LedgerAccountBase {
  entries: object[];
}

export interface LedgerAccountRead extends LedgerAccountBase {}

// Export the read list type
export type LedgerAccountReadList = {
  stats: TableStats;
  data: LedgerAccountRead[];
};
